import {
  collection, doc, onSnapshot, query, writeBatch, serverTimestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import { PLAN_ITEM_KINDS } from "./planItems";
import { TASK_LINKS } from "../tasks/taskLinks";
import { unlinkTasks } from "../tasks/taskLinkService";

const itemsRef = (uid, kind) => collection(db, "users", uid, PLAN_ITEM_KINDS[kind].collection);
const itemRef = (uid, kind, id) => doc(db, "users", uid, PLAN_ITEM_KINDS[kind].collection, id);

// Live list of one kind. Returns the unsubscribe function for effect cleanup.
export const subscribePlanItems = (uid, kind, onItems, onError) =>
  onSnapshot(query(itemsRef(uid, kind)), (snap) => {
    onItems(snap.docs.map(d => {
      const data = d.data();
      return { id: d.id, ...data, createdMs: data.createdAt?.toMillis?.() ?? 0 };
    }));
  }, onError);

export const addPlanItem = (uid, kind, { title, image = null }, sortOrder) => {
  const batch = writeBatch(db);
  const ref = doc(itemsRef(uid, kind));
  batch.set(ref, {
    title, image, sortOrder,
    createdAt: serverTimestamp(), updatedAt: serverTimestamp(),
  });
  return batch.commit().then(() => ref.id);
};

export const updatePlanItem = (uid, kind, id, fields) => {
  const batch = writeBatch(db);
  batch.set(itemRef(uid, kind, id), { ...fields, updatedAt: serverTimestamp() }, { merge: true });
  return batch.commit();
};

// Deleting a dream keeps its tasks, no longer tied to it.
export const deletePlanItem = async (uid, kind, id) => {
  const batch = writeBatch(db);
  batch.delete(itemRef(uid, kind, id));
  if (TASK_LINKS[kind]) await unlinkTasks(batch, uid, TASK_LINKS[kind], id);
  return batch.commit();
};

// Writes the new order in one batch, touching only the items whose position changed.
export const writePlanOrder = (uid, kind, orderedIds, items) => {
  const current = new Map(items.map(it => [it.id, it.sortOrder]));
  const batch = writeBatch(db);
  let changed = 0;
  orderedIds.forEach((id, i) => {
    if (current.get(id) === i) return;
    batch.set(itemRef(uid, kind, id), { sortOrder: i }, { merge: true });
    changed += 1;
  });
  return changed ? batch.commit() : Promise.resolve();
};
